var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6742 13.383C15.5847 13.4726 15.4621 13.5292 15.3207 13.5292C15.0473 13.5292 14.821 13.3029 14.821 13.0295L14.821 7.80633L9.59782 7.80633C9.3244 7.80633 9.09813 7.58006 9.09813 7.30664C9.09813 7.03323 9.3244 6.80695 9.59782 6.80695L15.3207 6.80695C15.5941 6.80695 15.8204 7.03322 15.8204 7.30664L15.8204 13.0295C15.8204 13.1709 15.7638 13.2935 15.6742 13.383Z",
    fill: "#2E9E3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.594 7.74013L7.66027 15.6739C7.46699 15.8671 7.14644 15.8671 6.95316 15.6739C6.75989 15.4806 6.75989 15.16 6.95316 14.9668L14.8869 7.03302C15.0802 6.83974 15.4007 6.83975 15.594 7.03302C15.7873 7.2263 15.7873 7.54685 15.594 7.74013Z",
    fill: "#2E9E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceUp);
export default __webpack_public_path__ + "static/media/price-up.456a5e9df8601183a281f632a2f3842f.svg";
export { ForwardRef as ReactComponent };